export default "__VITE_ASSET__DcD6cm98__"